import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";
import { IRetornoObterSolicitacoesDoUsuario } from "./ObterSolicitacoesDoUsuario";

export const ObterSolicitacoesDoUsuarioComFiltroDeData = async (
  CurrentPage: number,
  dataInicial: string,
  dataFinal: string
) => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IRetornoObterSolicitacoesDoUsuario>(
      `/solicitacaosenhaporusuariocomdata`,
      {
        params: { token, CurrentPage, Limit: 10, dataInicial, dataFinal },
      }
    );

    return data;
  } catch (erro) {
    throw new ApiException(
      erro,
      "Erro ao buscar solicitações do usuário usando a data"
    );
  }
};